import React, { Component, createRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { Pagination } from "antd"
import HUBContext from '../services/HUBContext'
import { NextIcon, PrevIcon, PagerJumpIcon } from '../common/icons'

class CustomPaginator extends Component {

    state = {
        width: 0
    }

    constructor(props) {
        super(props)

        this.componentRef = createRef()
    }

    componentDidMount() {
        this.resizeObserver = new ResizeObserver(e => {
            for (let entry of e) {
                this.setState({ width: entry.contentRect.width })
            }
        })

        this.resizeObserver.observe(this.componentRef.current)
    }

    componentWillUnmount() {
        this.resizeObserver.unobserve(this.componentRef.current)
    }

    paginationItemRender = (_, type, originalElement) => {
        switch(type) {
            case 'jump-prev':
            case 'jump-next':
                return <PagerJumpIcon />

            case 'prev':
                return <PrevIcon />

            case 'next':
                return <NextIcon />

            case 'page':
            default:
                return originalElement
        }
    }

    render() {
        const { pagerInfo, pageSizeOptions, onChange, onShowSizeChange, options, leftOptions, rightOptions, showLessItems } = this.props
        const { width } = this.state

        return <div className='pagination-section' ref={this.componentRef} style={{ justifyContent: width < (!!showLessItems ? 700 : 840) ? 'center' : 'space-between' }}>
            <div className='pagination-section-left' style={{ display: width < (!!showLessItems ? 700 : 840) ? 'none' : 'flex' }}>
                <span><FormattedMessage id='show' defaultMessage='Show' />:</span>
                <Pagination
                    showSizeChanger
                    current={(pagerInfo?.pageIndex || 0) + 1}
                    pageSize={pagerInfo?.pageSize || 5}
                    total={pagerInfo?.count || 0}
                    pageSizeOptions={pageSizeOptions || ['5', '10', '20', '30', '40', '50']}
                    onChange={(current) => {
                        if (typeof onChange === 'function' )
                            onChange(current)
                    }}
                    onShowSizeChange={(current, size) => {
                        if (typeof onShowSizeChange === 'function')
                            onShowSizeChange(current, size)
                    }}
                    locale= {{ items_per_page: "" }}
                    {...(options || {})}
                    {...(leftOptions || {})} />
                    
                <span className="pagerInfo">
                    <FormattedMessage
                        id="pagerInfo"
                        defaultMessage="{0} - {1}, of {2} records."
                        values={[
                            ((pagerInfo?.pageIndex || 0) * (pagerInfo?.pageSize || 5)) + 1,
                            (((pagerInfo?.pageIndex || 0) + 1) * (pagerInfo?.pageSize || 5)) > (pagerInfo?.count || 0) ? (pagerInfo?.count || 0) : (((pagerInfo?.pageIndex || 0) + 1) * (pagerInfo?.pageSize || 5)),
                            (pagerInfo?.count || 0)]} />
                </span>
            </div>
            <div className='pagination-section-right'>
                <Pagination
                    showLessItems={!!showLessItems}
                    current={(pagerInfo?.pageIndex || 0) + 1}
                    pageSize={pagerInfo?.pageSize || 5}
                    total={pagerInfo?.count || 0}
                    pageSizeOptions={pageSizeOptions || ['5', '10', '20', '30', '40', '50']}
                    itemRender={this.paginationItemRender}
                    onChange={(current) => {
                        if (typeof onChange === 'function' )
                            onChange(current)
                    }}
                    onShowSizeChange={(current, size) => {
                        if (typeof onShowSizeChange === 'function')
                            onShowSizeChange(current, size)
                    }}
                    {...(options || {})}
                    {...(rightOptions || {})} />
            </div>
        </div>
    }
}
CustomPaginator.contextType = HUBContext
export default CustomPaginator